const ModalIds = {
    CREATE_ADMIN: 'createAdminModal',
    DEACTIVATE_ADMIN_CONFIRM: 'deactivateAdminConfirmModal',
    REACTIVATE_ADMIN_CONFIRM: 'reactivateAdminConfirmModal',
    CREATE_CLIENT: 'createClientModal',
    CREATE_COMPANY: 'createCompanyModal',
    CREATE_USER: 'createUserModal',
    EDIT_USER: 'editUserModal',
    DISPLAY_USER: 'displayUserModal',
    EDIT_CLIENT: 'editClientModal',
    EDIT_COMPANY: 'editCompanyModal',
    DISPLAY_COMPANY: 'displayCompanyModal',
    CREATE_CALCULATION: 'createCalculationModal',
    CREATE_CALCULATION_CONFIRM: 'createCalculationConfirmModal',
    UPLOAD_BALANCE_ERROR: 'uploadBalanceErrorModal',
    ADD_DOCUMENTS: 'addDocumentsModal',
    ADD_COMMENTS: 'addCommentsModal',
    CALCULATION_REUSABLE_DOCUMENTS: 'calculationReusableDocumentsModal',
    CALCULATION_SEND_TO_VERIFIER: 'calculationSendToVerifierModal',
    CALCULATION_SEND_TO_APPROVER: 'calculationSendToApproverModal',
    CALCULATION_REJECT: 'calculationRejectModal',
    CALCULATION_APPROVE: 'calculationApproveModal',
    CALCULATION_CLOSE_FOR_SUBMISSION_NON_UNIVERSAL_ROLE: 'calculationCloseForSubmissionNonUniversalRoleModal',
    CALCULATION_CLOSE_FOR_SUBMISSION_UNIVERSAL_ROLE: 'calculationCloseForSubmissionUniversalRoleModal',
    CALCULATION_REOPEN_NON_UNIVERSAL_ROLE: 'calculationReopenNonUniversalRoleModal',
    CALCULATION_REOPEN_UNIVERSAL_ROLE: 'calculationReopenUniversalRoleModal',
    CALCULATION_CONFIRM_SUBMISSION: 'calculationConfirmSubmissionModal',
    CALCULATION_APPROVE_REOPENING: 'calculationApproveReopeningModal',
    CALCULATION_REJECT_REOPENING: 'calculationRejectReopeningModal',
    CALCULATION_RECALL: 'calculationRecallModal',
    REPLACE_BALANCE_CONFIRM: 'replaceBalanceConfirmModal',
    CALCULATION_TAKEN_OVER: 'calculationTakenOverModal',
    IDLE_USER: 'idleUserModal',
    LOGOUT_CONFIRM: 'logoutConfirmModal',
    DELETE_DOCUMENT_CONFIRM: 'deleteDocumentConfirmModal',
    DELETE_CALCULATION_CONFIRM: 'deleteCalculationConfirmModal',
    DELETE_COMPANY_CONFIRM: 'deleteCompanyConfirmModal',
    DELETE_CLIENT_CONFIRM: 'deleteClientConfirmModal',
    DEACTIVATE_CLIENT_CONFIRM: 'deactivateClientConfirmModal',
    REACTIVATE_CLIENT_CONFIRM: 'reactivateClientConfirmModal',
    DEACTIVATE_OPERATIONS_CLIENT_CONFIRM: 'deactivateOperationsClientConfirm'
};
export default ModalIds;
